const addDays = function(days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    return d.toISOString();
};

export default addDays;
